import React from 'react';
import { Link } from 'react-router-dom';

import { CUISINE_LINKS, SEATTLE_LOCATIONS, PORTLAND_LOCATIONS, SEATTLE_TRUCKS, PORTLAND_TRUCKS } from './navLinks';
import styles from './MegaMenu.module.postcss';

function FoodTrucksMenu({ cityName, vehicleType }) {
  const isPortland = cityName === 'Portland';
  const locations = isPortland ? PORTLAND_LOCATIONS : SEATTLE_LOCATIONS;
  const trucks = isPortland ? PORTLAND_TRUCKS : SEATTLE_TRUCKS;

  return (
    <div className={styles.MegaMenu_grid}>
      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>By Cuisine</strong>
        <ul>
          { CUISINE_LINKS.map((link) => (
            <li key={link.url}>
              <Link to={link.url}>{link.emoji} {link.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/explore' className={styles.MegaMenu_viewAll}>
          Explore All {vehicleType}s
        </Link>
      </div>

      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>Popular Locations</strong>
        <ul>
          { locations.map((loc) => (
            <li key={loc.url}>
              <Link to={loc.url}>{loc.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/explore' className={styles.MegaMenu_viewAll}>
          Find Near Me
        </Link>
      </div>

      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>Top Food {vehicleType}s</strong>
        <ul>
          { trucks.map((truck) => (
            <li key={truck.url}>
              <Link to={truck.url}>{truck.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/food-trucks' className={styles.MegaMenu_viewAll}>
          Browse All
        </Link>
      </div>
    </div>
  );
}

export default React.memo(FoodTrucksMenu);
